module.exports = __webpack_public_path__ + "assets/img/NPC024.40de2ef1.png";